import { render, staticRenderFns } from "./siteIndHygieneJournalDetail.vue?vue&type=template&id=3e6f0310"
import script from "./siteIndHygieneJournalDetail.vue?vue&type=script&lang=js"
export * from "./siteIndHygieneJournalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e6f0310')) {
      api.createRecord('3e6f0310', component.options)
    } else {
      api.reload('3e6f0310', component.options)
    }
    module.hot.accept("./siteIndHygieneJournalDetail.vue?vue&type=template&id=3e6f0310", function () {
      api.rerender('3e6f0310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/siteIndHygieneJournalDetail.vue"
export default component.exports